import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';

import { SearchResultPublisherNetworkQuestions } from './types';

export type SearchResultPublisherNetworkQuestionAction = SearchLoadFulfilledAction | SearchLoadMoreFulfilledAction;

const initialState: SearchResultPublisherNetworkQuestions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<SearchResultPublisherNetworkQuestions, SearchResultPublisherNetworkQuestionAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.searchResultsPublisherNetworkQuestions);
    default:
      return state;
  }
};

export default reducer;
